import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

// Import all the components dynamically
import GeneralInformation from "./GeneralInformation";
import CookieInformative from "./CookieInformation";
import PrivacyPolicy from "./PrivacyPolicy";
import HeaderBar from "../HeaderBar";
import ContactForm from "./ContactForm";
import Questions from "./Questions";

const GeneralContainer = () => {
  const menuItems = [
    { label: "General Informations", component: <GeneralInformation /> },
    { label: "Frequently Asked Questions", component: <Questions /> },
    { label: "Contact Us", component: <ContactForm /> },
    { label: "Cookie informative", component: <CookieInformative /> },
    { label: "Privacy Policy", component: <PrivacyPolicy /> },
  ];

  // State to track the selected menu item
  const [selectedItem, setSelectedItem] = useState(menuItems[0].label);

  return (
    <Box>
      {/* Header */}
      <HeaderBar />

      {/* Main Layout */}
      <Grid
        container
        spacing={0}
        sx={{ padding: "calc(var(--banner-height, 0px) + var(--nav-height, 68px)) 0px 20px", minHeight: "100vh" }}
      >
        {/* Left Navigation */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            borderRight: { xs: "none", sm: "none", md: "1px solid #eee" },
            borderBottom: {
              xs: "1px solid #eee",
              sm: "1px solid #eee",
              md: "none",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              px: { xs: "2rem", sm: "2rem", md: "1rem" },
            }}
          >
            General Informations
          </Typography>
          <List>
            {menuItems.map((item) => (
              <ListItem
                key={item.label}
                component="button" // Explicitly render as a button
                onClick={() => setSelectedItem(item.label)}
                sx={{
                  backgroundColor:
                    selectedItem === item.label ? "#f0f0f0" : "inherit",
                  borderRadius: "4px",
                  marginBottom: "4px",
                  border: "none", // Remove default button border
                  textAlign: { xs: "center", sm: "center", md: "left" }, // Align text like a list item
                  cursor: "pointer", // Show pointer cursor
                  padding: "8px 16px", // Add padding to match ListItem style
                  color: "inherit",
                  width: "100%", // Ensure full width
                  display: "block",
                  px: "32px",
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: selectedItem === item.label ? "bold" : "normal",
                    color: selectedItem === item.label ? "#0077ff" : "#000",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Right Content */}
        <Grid item xs={12} md={9}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              px: "32px",
              pt: { xs: "24px", sm: "24px", md: "0px" },
            }}
          >
            {selectedItem}
          </Typography>

          {/* Dynamically Render the Selected Component */}
          <Box sx={{ pl: "2rem" }}>
            {menuItems.find((item) => item.label === selectedItem)?.component}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GeneralContainer;
